import styled from 'styled-components'
import * as palette from 'styles/palette'
import Typography from '@material-ui/core/Typography'

export const StepWrapper = styled.div`
  min-height: 45rem;
  margin-bottom: 3rem;
  position: relative;
  @media (max-width: 640px) {
    min-height: 42rem;
  }`

export const ProgressContainer = styled.div`
  padding: 0 5rem;
  position: relative;
  height: 100%;
  
  background-color: ${palette.white};
  
  @media (max-width: 600px) {
    padding: 0 1.8rem;
  }
  @media (max-width: 360px) {
    padding: 0 1.8rem;
  }
`

export const MainWrapper = styled(Typography)`
 &&& {
  font-size: 3.6rem;
  font-weight: bold;
  line-height: 6.1rem;
  text-align: left;
  margin-left: 7rem;
  margin-right: 7rem;
 }`

export const StyledHeader = styled.div`
color: white;
background-color: #12A5A9;
height: 100px;
box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
`

export const StyledTitle = styled.div`
text-align: center;
line-height: 1.5;
padding: 1rem;
padding-top: 2.5rem;
font-size: 1.8rem;
font-family: Nunito, sans-serif;
font-weight: bold;
  @media (max-width: 600px) {
    padding: 2rem;
  }

`

export const StyledWord = styled.p`
display:inline;
font-weight: bolder;
font-size: 1.6rem;
`
export const Spinner = styled.div`
padding: 220px;
  @media (max-width: 600px) {
    padding: 154px;
    margin-top: 74px;
    margin-left: 25px;
  }
`

export const SubmitSpinner = styled.div`
margin-left: 169px;
`
